import React, { useState } from 'react';
import Fab from '@mui/material/Fab';
import AddScreenIcon from '../../Assets/svgs/add_screen_image.svg'
import TTSIcon from '../../Assets/svgs/tts.svg'
import { makeStyles } from '@material-ui/core/styles';
import zIndex from '@mui/material/styles/zIndex';



// const useStyles = makeStyles((theme) => ({
//   fab: (props) => ({
//     backgroundColor: '#F27C21',
//     // color: theme.palette.getContrastText(props.backgroundColor), // Ensure text contrast
//     // minWidth: 120, // Set a minimum width
//     // transition: 'width 0.2s ease-in-out',
//     // display: 'flex',
//     // alignItems: 'center',
//     // justifyContent: 'space-between',

//     display: 'flex', // Enable horizontal layout
//         alignItems: 'center', // Align icon and text vertically
//         justifyContent: 'center', // Distribute content evenx`ly
//         transition: 'width 0.2s ease-in-out', // Smooth transition
//         width: expanded ? 180 : 40,
//       }), // Dynamic width for expanded and collapsed states    }),

// }));



const ExpandableFab = ({ clickFuntion, text, iconName}) => {

  const [expanded, setExpanded] = useState(false);
  // const classes = useStyles();
  const handleHover = () => setExpanded(true);
  const handleUnhover = () => setExpanded(false);




  const buttonStyle = {
    display: 'flex', // Enable horizontal layout
    alignItems: 'center', // Align icon and text vertically
    justifyContent: 'center', // Distribute content evenx`ly
    zIndex: 1,
    transition: 'width 0.2s ease-in-out', // Smooth transition
    width: expanded ? 250 : 40, // Dynamic width for expanded and collapsed states
    backgroundColor: iconName == "0" ? '#F27C21' : '#1776EE',
    color: 'white'

};

const iconComponent = () => {
    // Import your icon components based on iconName
    switch (iconName) {
      case '0':{
        // setBGColor('#F27C21');
        return <img src={AddScreenIcon} alt="Add screen image" />;
      }
      case '1':
        // setBGColor('#F27C83');
        return <img src={TTSIcon} alt="Text to speech" />;
      default:
        return null;
    }
  };

  return (
    <Fab
    variant='extended'
      onMouseEnter={handleHover}
      onMouseLeave={handleUnhover}
      style={buttonStyle}

      onClick={clickFuntion}
      // className={classes.fab}
      // color="transparent"
    >
      {/* <AddIcon /> */}
      {iconComponent()}
      {expanded && <span style={{marginLeft: '10px', textTransform: 'none'}}>{text}</span>}
    </Fab>
  );
};

export default ExpandableFab;